import { gql } from 'graphql-tag'

export const CONSUMER_HAD_RECENT_SUPPORT_INTERACTION = gql`
  query ConsumerHadRecentSupportInteraction {
    consumerHadRecentSupportInteraction
  }
`
